var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6926_1516)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09375 2.8475C1.05231 2.8475 1.01257 2.86458 0.983265 2.89497C0.953962 2.92537 0.9375 2.9666 0.9375 3.00958V12.4104C0.9375 12.4999 1.0075 12.5725 1.09375 12.5725H13.9062C13.9477 12.5725 13.9874 12.5554 14.0167 12.525C14.046 12.4946 14.0625 12.4534 14.0625 12.4104V3.00958C14.0625 2.9666 14.046 2.92537 14.0167 2.89497C13.9874 2.86458 13.9477 2.8475 13.9062 2.8475H1.09375ZM0 3.00958C0 2.38329 0.49 1.875 1.09375 1.875H13.9062C14.51 1.875 15 2.38329 15 3.00958V12.4104C15 12.7113 14.8848 12.9999 14.6796 13.2127C14.4745 13.4255 14.1963 13.545 13.9062 13.545H1.09375C0.803669 13.545 0.52547 13.4255 0.320352 13.2127C0.115234 12.9999 0 12.7113 0 12.4104L0 3.00958Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9.73925V5.25925C5.62509 5.20319 5.64026 5.1482 5.66891 5.10002C5.69757 5.05185 5.73865 5.01226 5.78786 4.98542C5.83707 4.95858 5.89259 4.94547 5.94861 4.94746C6.00462 4.94946 6.05907 4.96648 6.10625 4.99675L9.59125 7.23612C9.63538 7.26439 9.67169 7.30331 9.69683 7.34929C9.72198 7.39527 9.73516 7.44684 9.73516 7.49925C9.73516 7.55165 9.72198 7.60322 9.69683 7.6492C9.67169 7.69518 9.63538 7.7341 9.59125 7.76237L6.10625 10.0024C6.05907 10.0326 6.00462 10.0497 5.94861 10.0517C5.89259 10.0536 5.83707 10.0405 5.78786 10.0137C5.73865 9.98685 5.69757 9.94727 5.66891 9.89909C5.64026 9.85092 5.62509 9.79592 5.625 9.73987V9.73925Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6926_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.427488c6c9746fe55bbfaeca427953a3.svg";
export { ForwardRef as ReactComponent };